






















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';
import flagKeys from '@/constants/flagKeys';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class CampaignCreationFeedbackModal extends Vue {
  @Prop({ default: false }) readonly immediateActivation?: boolean;
  @Prop() readonly onCloseModal?: () => void;

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get textWelcome() {
    return 'Welcome Coins';
  }

  onClose() {
    if (this.onCloseModal) {
      this.onCloseModal();
    }
    eventBus.$emit('closeModal');
  }

  onShare() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'campaignShareModal',
        false,
        true,
        true,
        true,
        true
      ),
      { modalViewEvent: 'Free Coins/Share' }
    );
  }
}
